module.exports = __webpack_public_path__ + "static/media/foods_selected.43ae58db.svg";